//--
import request from "../../../core/wrappers/axios-wrapper";
import { ApiURL } from "../../../types/constants/apiUrls/api-urls";
 

import { RequestType } from "../../../types/enums/request-enums";
 //#region comment metod
 const GetStockDetail=(params:any)=>request({
  url: ApiURL.Query.getStockDetail,
  method: RequestType.GET,
  params : params
 });
 const GetProductDetail=(params:any)=>request({
  url: ApiURL.Query.getProductDetail+"?OptionId="+params,
  method: RequestType.GET,
 });
 const GetProductDetailAll=(params:any)=>request({
  url: ApiURL.Query.getProductDetailAll,
  method: RequestType.GET,
  params:params
 });
 const GetTeknikFoy=(params:any)=>request({
  url: ApiURL.Query.getTeknikFoy,
  method: RequestType.GET,
  params:params
 });
 const GetAllWarehouses=()=>request({
  url: ApiURL.Query.getAllWarehouses,
  method: RequestType.GET,
 });
 const GetWarehouseById=(params:any)=>request({
  url: ApiURL.Query.getAllWarehousesById+"?warehouseId="+params,
  method: RequestType.GET,
  params:params
 });
 const GetWarehouseByGroupId=(params:any)=>request({
  url: ApiURL.Query.getAllWarehousesByGroupId+"?warehouseGroupId="+params,
  method: RequestType.GET,
  params:params
 });
 const GetCentralStockInfo=(params?:any)=>request({
  url: ApiURL.Query.GetCentralStockInfo,
  method: RequestType.GET,
  params:params
 });
const SearchServiceQuery = {
  GetStockDetail,
  GetProductDetail,
  GetTeknikFoy,
  GetProductDetailAll,
  GetAllWarehouses,
  GetWarehouseById,
  GetWarehouseByGroupId,
  GetCentralStockInfo
};

export default SearchServiceQuery;
